<template>
  <div ref="word" class="Word" :class="{ 'onTop': over == true }">
    <div 
      :id="id"
      class="Word__item draggable" 
      :class="[{ 'disable': disable }, 'is-'+ color]"
      @mouseover="isOver()" 
      @mouseout="isOut()">{{ txt }}</div>
    <div ref="txt" class="Word__txt" :class="[{ left: id < 6 }]" v-if="description" v-html="desc"/>
  </div>
</template>
<script>

import { Descriptions_words } from '../js/Descriptions.js'

export default {
  name: 'Word',
  props: ['id', 'txt', 'pos', 'color', 'description'],
  data: () => ({
    disable: false,
    used: false,
    over: false,
    desc: null
  }),

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  created() {
    window.addEventListener('resize', this.onResize)
    this.desc = Descriptions_words[this.lang][this.oeuvre.name][this.id]
  },
  mounted(){
    this.$nextTick(()=>{
      TweenMax.delayedCall(.5, ()=>{
        this.setPosition()
        TweenMax.set(this.$refs.word, { scale: .0 })
        TweenMax.to(this.$refs.word, .7 ,{ opacity: 1, scale: 1, ease: Cubic.easeOut, delay: _.random(1, 1.75) })
      })
    })
  },
  watch: {
    drag_end(nw, od) {
      if(nw.id == this.id) {
        this.disable = true
        if(navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
          this.isOut(0)
      }
    },
    drag_back(nw, od) { 
      if(nw.id == this.id) {
        this.disable = false
      }
    },
    current_drag(nw, od) {
      if(nw.id == this.id) {
        if(navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
          this.isOver(0)
        else {
          this.used = true
          this.isOut(0)
        } 
      }
      else 
        this.used = false

    },
    is_over(nw, od) {
      if(nw == this.id) 
        this.over = true
      else 
        this.over = false  
    },
    hide_bubble(nw, od) {
      if(navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
        this.isOut(0)
    },
    lang(nw, od) {
      this.desc = Descriptions_words[this.lang][this.oeuvre.name][this.id]
    },
  },
  computed: {
    drag_end() { return this.$store.getters['app/drag_end'] },
    drag_back() { return this.$store.getters['app/drag_back'] },
    current_drag() { return this.$store.getters['app/current_drag'] },
    is_over() { return this.$store.getters['app/is_over'] },
    hide_bubble() { return this.$store.getters['app/hide_bubble'] },
  },
  methods: {
    onResize() {
      this.setPosition()
    },
    setPosition() { 
      const coef = (window.innerWidth <= 1200) ? .4 : .5
      const bounds = this.$refs.word.getBoundingClientRect()
      const inw = window.innerWidth/2
      const wid = Math.round(bounds.width)/2
      const inh = window.innerHeight/2
      const heg = Math.round(bounds.height)/2
      const psx = inw - wid +  this.pos[0]*coef
      const psy = inh - heg + this.pos[1]*(coef*1.15) + 2
      TweenMax.set(this.$refs.word, { x: psx  , y: psy })
    },
    isOver(_delay) {
      if(this.used || !this.description)
        return
      this.showTxt(_delay)
    },
    isOut(_delay) {
      if(!this.description)
        return
      this.hideTxt(_delay)
    },
    showTxt(_delay) {
      const delay = (_delay) ? _delay : .35
      this.$store.commit('app/IS_OVER', this.id)
      const pos = (this.id < 6) ? -20 : 20
      TweenMax.to(this.$refs.txt, .5, { opacity: 1, x: '+='+ pos, delay: delay })
    },
    hideTxt(_delay) {
      const delay = (_delay) ? _delay : .35
      const pos = (this.id < 6) ? -20 : 20
      TweenMax.to(this.$refs.txt, .25, { opacity: 0, x: '-='+ pos, delay: delay })
    },

  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Word
  position absolute
  height 36px
  border-radius 18px 
  background rgba(black, .3)
  font-size 16px
  transition opacity .25s 
  min-width 70px
  white-space nowrap
  opacity 0
  font-weight 300
  z-index 1

  +max-screen-height(tablet-portrait)
    height 32px
    font-size 13px

  &.onTop 
    z-index 10

  &__item
    height 36px
    padding 0 20px
    border-radius 18px
    display flex
    justify-content center
    align-items center
    background rgba(black, .5)
    font-size 16px
    cursor pointer 
    transition opacity .25s 
    min-width 70px
    z-index 500

    +max-screen-height(tablet-portrait)
      height 32px
      font-size 13px
      padding 0 16px

    &.is-yellow
      color #C5D204

    &.is-blue
      color #258AD6

    &.is-green
      color #3DE886

    &.disable 
      opacity 0
      pointer-event none

  &__txt 
    position fixed
    background black
    font-size 13px
    line-height 18px
    padding 8px 10px 10px 10px
   
    width auto
    top -60px
    left 20px

    pointer-events none
    opacity 0

    transform translateX(-100%)

    &.left
      transform translateX(0)


</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Word.vue